import { createContext, ReactNode, useMemo, useState } from 'react';
import { useCompanyAttributesQuery } from 'src/services/company/useCompanyAttributesQuery';
import { Company } from 'src/types/Companies';
import { SetState } from 'src/types/generic';

interface CompanyContextType {
  method: string;
  company: Company;
  changeCompany: SetState<Company>;
  attributes: string[];
}

export const CompanyContext = createContext<CompanyContextType | null>(null);

type CompanyProviderProps = {
  children: ReactNode;
};

export const companyInitialState = { companyName: 'Select a Company...', companyId: '' };

export const CompanyProvider = ({ children }: CompanyProviderProps) => {
  const [company, setCompany] = useState<Company>(companyInitialState);
  const { data: attributes = [] } = useCompanyAttributesQuery(Number(company.companyId));

  const CompanyProviderValue = useMemo(
    () => ({ company, changeCompany: setCompany, method: 'CompanyId', attributes }),
    [attributes, company]
  );

  return <CompanyContext.Provider value={CompanyProviderValue}>{children}</CompanyContext.Provider>;
};
